import { render, staticRenderFns } from "./NumberOfVesselsByType.vue?vue&type=template&id=620c14e2&"
import script from "./NumberOfVesselsByType.vue?vue&type=script&lang=js&"
export * from "./NumberOfVesselsByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports